import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import {Modal} from 'react-bootstrap';
import VendorTermsAndConditions from '../shared/components/VendorTermsAndConditions';
import {defineMessages, FormattedMessage} from 'react-intl';
import FormWrapper from 'components/FormWrapper';
import './TermsAndConditionsModal.css';
import Spinner from 'components/Spinner';
import { connect } from 'react-redux';
import * as constants from 'constants/App';
import * as appActions from '../actions/App';
import queryString from 'query-string'
import ReactDOM from 'react-dom';
import { useLocation } from 'react-router-dom';

const TermsAndConditionsModal = (props) => {
    const location = useLocation();
    const [, setModalLoaded] = useState(false);

    useEffect(() => {
        props.dispatch({type:constants.CLEAR_TERMS_AND_CONDITIONS});
    }, [props.dispatch]);

    const onCloseWindowHandler = () => {
        props.dispatch(appActions.signOut());
        props.dispatch({type:constants.NAVIGATE_TO, path: '/login'});
    };

    const onToggleAcceptedTermsHandler = () => {
        props.dispatch(appActions.termsAndConditionsToggleAccepted());
    };

    const onInitialsAcceptedTermsHandler = (tcInitialsValue) => {
        props.dispatch(appActions.termsAndConditionsInitialsAccepted(tcInitialsValue));
    };

    const onSubmitTermsHandler = () => {
        if ((props.tcInitialsAcceptedFlag != undefined && props.tcInitialsAcceptedFlag.length == 2) && props.toggleAcceptedFlag){
            let params =  queryString.parse(location.search);
            let returnUrl = params.returnUrl;
            if (!params.returnUrl) returnUrl = '/';

            props.dispatch(appActions.termsAndConditionsAccepted(true));
            props.dispatch({type: constants.ACCEPTED_TERMS_AND_CONDITIONS_SUBMISSION, returnUrl});
        }else{
            props.dispatch(appActions.tcConditionTermsAndConditionsChecked(true))
        }
    };

    const messages = defineMessages({
        close_dialog: {
            id: 'close_dialog',
            description: '  Close',
            defaultMessage: 'Close'
        },
        cancel_verify_caption: {
            id: 'cancel_verify_caption',
            description: 'Title for cancel button',
            defaultMessage: 'Cancel'
        },
        continue_verify_caption: {
            id: 'continue_verify_caption',
            description: 'Title for continue button',
            defaultMessage: 'Continue'
        },
        terms_and_conditions_subheader_login: {
            id: 'terms_and_conditions_subheader_login',
            description: 'terms_and_conditions_subheader_login',
            defaultMessage: "We're updating the terms for your account."
        },
        terms_and_conditions_header_login: {
            id: 'terms_and_conditions_header_login',
            description: 'terms_and_conditions_header_login',
            defaultMessage: 'Terms & Conditions'
        }
    });

    if (props.isFetchingTermsAndConditionsStatus ) {
        return <div className="terms_and_conditions_modal__save2"> <Spinner spinnerType="dark-blue"/> </div>;
    }

    return <div className="row container-fluid" >
        <div className="d-none d-xl-block links offset-lg-1 col-lg-1 offset-xl-1 col-xl-2">
            <Modal show={props.acceptedTermsAndConditions === "N" || props.isFetchingTermsAndConditionsAccepted}
                onHide={()=> props.acceptedTermsAndConditions === "Y" || props.termsAndConditions === null}
                dialogClassName="terms_and_conditions_modal__modal"
                backdrop="static"
                keyboard={false}
                onEntered={() => setModalLoaded(true)}
            >
                <Modal.Body>
                    <FormWrapper key='dealerDraftLineItemsErr'
                        id="dealerDraftLineItemsErr" {...props}
                        formErrors={props.errorMessage}/>
                    <div className="row terms_and_conditions_modal__close">
                        <div onClick={onCloseWindowHandler}>
                            <img
                                src="/assets/VMS_33button_kill_blue.png"/>
                            {"  "} {<FormattedMessage {...messages.close_dialog} />}
                        </div>
                    </div>
                    <div className='row terms_and_conditions_modal__header'>
                        <FormattedMessage {...messages.terms_and_conditions_header_login} />
                    </div>
                    <div className="row terms_and_conditions_modal__subheader">
                        <FormattedMessage {...messages.terms_and_conditions_subheader_login}/>
                    </div>
                    <VendorTermsAndConditions termsAndConditions={props.termsAndConditions}
                        toggleAcceptedFlag={props.toggleAcceptedFlag}
                        tcContinueValdiationFlag = {props.tcContinueValdiationFlag}
                        tcInitialsAcceptedFlag={props.tcInitialsAcceptedFlag}
                        onToggleAcceptedTerms={onToggleAcceptedTermsHandler}
                        onInitialsAcceptedTerms={onInitialsAcceptedTermsHandler}
                        isFetchingTermsAndConditions={props.isFetchingTermsAndConditions}
                    />
                    <div className="terms_and_conditions_modal__footer row">
                        <div className="col-md-9 terms_and_conditions_modal__caption"
                            onClick={onCloseWindowHandler}>

                            <img src="/assets/VMS_28button_delete_blue.png"/>{' '}
                            <a>
                                <FormattedMessage {...messages.cancel_verify_caption}/>
                            </a>
                        </div>
                        <div
                            className="terms_and_conditions_modal__caption2 col"
                            onClick={onSubmitTermsHandler}>
                            <a>
                                <FormattedMessage {...messages.continue_verify_caption}/>{' '}
                                <img src="/assets/VMS_28button_edit_clear.png"/>
                            </a>

                        </div>
                        <div className="terms_and_conditions_modal__save inline-block">
                            {props.isFetchingTermsAndConditionsAccepted ?
                                <Spinner spinnerType="dark-blue"/>
                                : undefined
                            }
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    </div>;
};

function mapStateToProps(state, props) {
    return {
        termsAndConditions:state.appState.getIn(['serverData', 'shared', 'vendorTermsAndConditions']) || null,
        acceptedTermsAndConditions:state.appState.getIn(['serverData', 'shared', 'acceptedTermsAndConditions']),
        toggleAcceptedFlag:state.appState.getIn(['uiData', 'shared', 'vendorTermsAndConditions','toggleAcceptedFlag']) || false,
        tcInitialsAcceptedFlag:state.appState.getIn(['uiData', 'shared', 'vendorTermsAndConditions','tcInitialsAcceptedFlag']) || undefined,
        tcContinueValdiationFlag:state.appState.getIn(['uiData', 'shared', 'vendorTermsAndConditions','tcContinueValdiationFlag']) || false,
        isFetchingTermsAndConditionsStatus:state.appState.getIn(['uiData', 'shared', 'vendorTermsAndConditions','isFetchingTermsStatus']) || false,
        isFetchingTermsAndConditions:state.appState.getIn(['uiData', 'shared', 'vendorTermsAndConditions','isFetchingTermsAndCondition']) || false,
        isFetchingTermsAndConditionsAccepted:state.appState.getIn(['uiData', 'shared', 'vendorTermsAndConditions','isFetchingTermsAndConditionAccepted']) || false,
        paymentType:state.appState.getIn(['serverData', 'shared', 'paymentType']) || null,
        selectedCountry:state.appState.getIn(['uiData', 'shared', 'selectedCountry']) || null,
    };
}

export default connect(mapStateToProps)(TermsAndConditionsModal);
